import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const IdField = ({ id, emptyBox, sx }: { id: string | number, emptyBox?: boolean, sx?: object }) => {
  const [copied, setCopied] = useState(false);
  if (typeof id === 'number') {
    id = id.toString();
  }
  if (!id) {
    if (emptyBox) {
      return <Box sx={sx} />;
    }
    return null;
  }

  const shortId = `${id.slice(0, 3)}...${id.slice(-3)}`;

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(id);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  }

  return (
    <Box display="flex" alignItems="center" width="100px" justifyContent='space-between' sx={sx}>
      <Tooltip title={id}>
        <Typography variant='body2' noWrap>{shortId}</Typography>
      </Tooltip>
      <Tooltip title={copied ? 'Copied!' : 'Copy'}>
        <IconButton onClick={handleCopy}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default IdField;
